<template>
  <div class="table-wrap" :class="{ 'no-scroll' : !scrollable }">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'tbl',

  props: {
    scrollable: {
      type: [String, Boolean],
      default: false
    },

    dataLoading: {
      type: [Boolean],
      default: true
    }
  },

  provide () {
    const tblConfig = this.tblConfig
    return { tblConfig }
  },

  data () {
    return {
      tblConfig: {
        loading: null,
        body_w: 0,
        td_name: null,
        asc: false
      }
    }
  },

  watch: {
    dataLoading () {
      this.tblConfig.loading = this.dataLoading

      if (!this.dataLoading) {
        this.setTableHeight()
      }
    }
  },

  mounted () {
    this.setTableHeight()
  },

  methods: {
    setTableHeight () {
      this.tblConfig.table_h = this.$parent.$el.offsetHeight
    }
  }
}
</script>
